export function shouldExcludeEUBusinessSeller(HWUserType, webTLD) {
  return HWUserType === 'BUSINESS' && shouldExcludeEUDomains(webTLD);
}

export function shouldExcludeEUDomains(webTLD) {
  return [
    'fr',
    'pl',
    'be',
    'it'
  ].includes(webTLD);
}

function isCurrencySFValid(currency) {
  return [
    'EUR',
    'GBP',
    'PLN',
    'SEK',
    'DKK'
  ].includes(currency);
}

// Extended to include USD and CAD
function isCurrencySFValidPlus(currency) {
  return [
    'EUR',
    'GBP',
    'PLN',
    'SEK',
    'DKK',
    'USD',
    'CAD'
  ].includes(currency);
}

export function isHWNewUser(IsHWRegistered, currency) {
  if (!IsHWRegistered) {
    if (/^1|true$/i.test(process.env.REACT_APP_HW_USD_CAD_ENABLED)) {
      return isCurrencySFValidPlus(currency);
    } else {
      return isCurrencySFValid(currency);
    }
  }
  return false;
}
